const resourceTypes = {
  Paths: "Paths",
  Actions: "Actions",
};
export default resourceTypes;
